import { genericPage, getServerSidePropsHelper, getSlugEleccio, getMappingEleccions3CatInfo } from 'components/3catinfo/Page';
import { useRouter } from 'next/router';

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions']);
};

export async function getServerSideProps(context) {
    const slugEleccio = getSlugEleccio(context?.resolvedUrl);
    const mapping = await getMappingEleccions3CatInfo(slugEleccio);
    let path = ['web', process.env.FOLDER_LAYOUTS_3CATINFO, 'eleccions', slugEleccio, 'faqs'];

    const options = {
        slugs: path,
        id: mapping.id,
        slugEleccio
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
